import sendApproveBenefitRequest from "v2/infrastructure/BenefitRequests/repositories/sendApproveBenefitRequest";

const approveBenefitRequest = ({
  companyId,
  requestId,
}: {
  companyId: string;
  requestId: string;
}) => {
  return sendApproveBenefitRequest({ companyId, requestId });
};

export default approveBenefitRequest;
